module.exports = __webpack_public_path__ + "static/media/offers.1f51cced.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/offers.jpg
// module id = 366
// module chunks = 33